import { render, staticRenderFns } from "./SubscriptionDeactivationReasonSelector.vue?vue&type=template&id=487106e8&scoped=true&"
import script from "./SubscriptionDeactivationReasonSelector.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionDeactivationReasonSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionDeactivationReasonSelector.vue?vue&type=style&index=0&id=487106e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487106e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487106e8')) {
      api.createRecord('487106e8', component.options)
    } else {
      api.reload('487106e8', component.options)
    }
    module.hot.accept("./SubscriptionDeactivationReasonSelector.vue?vue&type=template&id=487106e8&scoped=true&", function () {
      api.rerender('487106e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/SubscriptionDeactivationReasonSelector.vue"
export default component.exports